






import { Component, Vue } from "vue-property-decorator";
import { getQueryParam } from "@/utils/index";
import PageResult from "@/components/PageResult.vue";

@Component({
    components: {
        "v-page-result": PageResult
    }
})
export default class NoAccess extends Vue {
    icon: any = require("../../assets/images/ic_fetal.png");
    msg: string = "";

    mounted() {
      this.msg = decodeURI(getQueryParam(this.$route, "msg"));
    }
}
